import { useStore as u } from "@nanostores/react";
import { useCallback as a } from "react";
import { addCopilotFiles as c, uploadCopilotFile as m, uploadAllCopilotFiles as n, validateFile as f } from "../file-upload.js";
function w(l) {
  const e = u(l.__uploadFiles), o = a(
    (t) => c(l, t),
    [l]
  ), r = a(
    async (t) => await m(l, t),
    [l]
  ), i = a(async () => await n(l), [l]), p = a(
    (t) => {
      l.removeUploadFile(t);
    },
    [l]
  ), d = a(() => {
    l.clearUploadFiles();
  }, [l]), F = a((t) => f(t), []);
  return {
    files: e,
    addFiles: o,
    uploadFile: r,
    uploadAllFiles: i,
    removeFile: p,
    clearFiles: d,
    validateFile: F
  };
}
export {
  w as useCopilotFileUpload
};
